/**
 * @generated SignedSource<<328c09410a7466f00f74849cd5dfcec8>>
 * @relayHash 92106690bb7e678270694af845fb5480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueSubscription$variables = {
  atlassianAccountId: string;
  cloudId: string;
  events: ReadonlyArray<string>;
  projectIds: ReadonlyArray<string>;
};
export type IssueSubscription$data = {
  readonly jira: {
    readonly onJirtIssueSubscription: {
      readonly actionerAccountId: string | null | undefined;
      readonly project: {
        readonly id: number;
      };
      readonly resource: string;
      readonly type: string;
    } | null | undefined;
  } | null | undefined;
};
export type IssueSubscription = {
  response: IssueSubscription$data;
  variables: IssueSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "events"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIds"
},
v4 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "atlassianAccountId",
            "variableName": "atlassianAccountId"
          },
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "events",
            "variableName": "events"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraJirtEventPayload",
        "kind": "LinkedField",
        "name": "onJirtIssueSubscription",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "actionerAccountId"
          },
          {
            "kind": "ScalarField",
            "name": "resource"
          },
          {
            "concreteType": "JiraIssueStreamHubEventPayloadProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueSubscription",
    "selections": (v4/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueSubscription",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068",
    "metadata": {},
    "name": "IssueSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "1288b7ac81835d68c9265e8c3bdfa3d5";

export default node;
